import { FloatButton } from "antd";
import Typography from "app/shared/Typography";
import ReactPlayer from "react-player";
import { AgTableClient } from "app/shared/AgTable";
import JsonData from "./jsonData.json";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  RightCircleOutlined,
} from "@ant-design/icons";

export default function OnboardHotelReconView(props: any) {
  const openSidebarRenderer = (params: any) => {
    params.api.openToolPanel("pdfRenderer", { paramData: params });
  };

  const columnDefs = [
    {
      headerName: "Invoice",
      field: "Invoice_link",
      filter: "agTextColumnFilter",
      invoiceLink: "html.pdf",
      cellRenderer: ToolParamInvoker,
      cellRendererParams: (params: any) => {
        return {
          label: "View Invoice",
          handleClick: openSidebarRenderer,
          data: params.data?.Invoice_link || params?.value,
        };
      },
    },
    {
      headerName: "Vendor Name",
      field: "vendor_name_einvoice",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      formatType: "ENTITY",
    },

    {
      headerName: "MMT Booking Id",
      field: "MMT Booking Id",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Vendor State",
      field: "Vendor State",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Vendor GSTIN",
      field: "vendor_gstin",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Vendor PAN",
      field: "vendor_pan",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Customer GSTIN",
      field: "customer_gstin",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Customer PAN",
      field: "customer_pan",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Invoice Number",
      field: "invoice_number",
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Invoice Date",
      field: "invoice_date",
      filter: "agDateColumnFilter",
      formatType: "DATE",
    },
    {
      headerName: "Taxable Amount",
      field: "taxable_amount",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "CGST Amount",
      field: "cgst_amount",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "SGST Amount",
      field: "sgst_amount",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "Total GST",
      field: "Total GST",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "Total Amount",
      field: "total_amount",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "Invoice Type",
      field: "invoice_type",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Filing Period",
      field: "filing_period",
      filter: "agDateColumnFilter",
      formatType: "DATE",
    },
    {
      headerName: "Eligibility Status",
      field: "eligiblity_status",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            Eligible: "green",
          },
          icon: {
            Eligible: <CheckCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "Unique Identifier",
      field: "eunique",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Buyer GSTIN",
      field: "BuyerDtls.Gstin",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Document Number",
      field: "DocDtls.No",
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Document Date",
      field: "DocDtls.Dt",
      filter: "agDateColumnFilter",
    },
    { headerName: "IRN", field: "Irn", filter: "agTextColumnFilter" },
    {
      headerName: "IRN Date",
      field: "IrnDt",
      filter: "agDateColumnFilter",
      formatType: "DATE",
    },
    {
      headerName: "CGST Amount",
      field: "CgstAmt",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "SGST Amount",
      field: "SgstAmt",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "IGST Amount",
      field: "IgstAmt",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "IRN Total GST",
      field: "irn Total GST",
      filter: "agNumberColumnFilter",
      formatType: "AMOUNT",
      enableValue: true,
    },
    {
      headerName: "Vendor Type",
      field: "Vendor_Type_Irn",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },

    {
      headerName: "Invoice Status",
      field: "Invoice Status",
      filter: "agTextColumnFilter",
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            "Invoice received": "green",
            Match: "yellow",
          },
          icon: {
            "Invoice received": <CheckCircleFilled />,
            Match: <CloseCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "GST Difference",
      field: "gstdifference",
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "GST Status",
      field: "GST Status",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            "Extact Match": "green",
            Match: "yellow",
          },
          icon: {
            "Extact Match": <CheckCircleFilled />,
            Match: <CloseCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "Vendor GST Status",
      field: "Vendor GST Status",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            Match: "green",
          },
          icon: {
            Match: <CheckCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "Invoice Number Status",
      field: "Invoice Number Status",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            Match: "green",
          },
          icon: {
            Match: <CheckCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "Match Status",
      field: "Match Status",
      filter: "agTextColumnFilter",
      formatType: "MATCH",
      enableRowGroup: true,
      formatProps: {
        matchLogic: {
          matchColor: {
            "Perfect Match": "green",
            Match: "yellow",
          },
          icon: {
            "Perfect Match": <CheckCircleFilled />,
            Match: <CloseCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
    {
      headerName: "Claimable Eligibility Status",
      field: "Claimable Eligibility_Status",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      formatType: "MATCH",
      formatProps: {
        matchLogic: {
          matchColor: {
            "Claimable-Eligible": "green",
            "Claimable-Not-Eligible": "red",
          },
          icon: {
            "Claimable-Eligible": <CheckCircleFilled />,
            "Claimable-Not-Eligible": <CloseCircleFilled />,
          },
        },
        defaultText: "Not Available",
      },
    },
  ];
  return (
    <div className="Greeting" style={{ height: "100%" }}>
      <div className="TableContainer" style={{ height: "100%" }}>
        <AgTableClient
          // @ts-ignore
          rowData={JsonData}
          columnDefs={columnDefs}
          groupPanel
          enablePDFViewer
          pdfDataKey="Invoice_link"
          onColGroup={props.onColGroup && props.onColGroup}
          defaultPivot={[""]}
          // autoGroupColumnDef={["Vendor Name"]}
          // pinnedBottomRowData={summarizedData}
          grandTotalRow
        />
      </div>
      {props.noFloat ? null : (
        <FloatButton
          onClick={props.goNext}
          style={{ marginRight: 24, width: 200 }}
          shape="square"
          type="primary"
          icon={
            <div style={{ display: "flex", width: "100%" }}>
              <Typography style={{ color: "white", marginRight: 6 }}>
                Next
              </Typography>
              <RightCircleOutlined />
            </div>
          }
        />
      )}
    </div>
  );
}
